import React from "react";
import MyAccountTab from "./MyAccountTab";
import CashierTab from "./CashierTab";
import CouponTab from "./CouponTab";
import RefundTab from "./RefundTab";
import BonusTab from "./BonusTab";
import ReferFriendTab from "./ReferFriendTab";
import AutoPromoTab from "./AutoPromoTab";
import WheelSpinTab from "./WheelSpinTab";
import ActivityTab from "./ActivityTab";
import ReviewTab from "./ReviewTab";

export const menuTabs = [
  {
    id: "account",
    label: "บัญชีของฉัน",
    icon: "fluent-color:person-16",
    component: MyAccountTab,
    group: "deposit",
  },
  {
    id: "autoPromo",
    label: "ตั้งค่าโปรโมชั่น",
    icon: "fluent-color:gift-24",
    component: AutoPromoTab,
    group: "promotion",
  },
  {
    id: "deposit",
    label: "ฝากเงิน",
    icon: "solar:add-circle-bold-duotone",
    component: () => <CashierTab initialTab="deposit" hideTabs />,
    group: "deposit",
  },
  {
    id: "withdraw",
    label: "ถอนเงิน",
    icon: "solar:minus-circle-bold-duotone",
    component: () => <CashierTab initialTab="withdraw" hideTabs />,
    group: "deposit",
  },
  {
    id: "cashtocredit",
    label: "แลกกระเป๋าเงินสด",
    icon: "fluent-color:arrow-clockwise-dashes-32",
    component: () => <CashierTab initialTab="cashtocredit" hideTabs />,
    group: "deposit",
  },

  {
    id: "history",
    label: "ประวัติธุรกรรม",
    icon: "fluent-color:text-bullet-list-square-sparkle-32",
    component: () => <CashierTab initialTab="history" hideTabs />,
    group: "deposit",
  },
  {
    id: "contact",
    label: "ติดต่อเรา",
    icon: "fluent-color:headset-48",
    component: null,
    group: "deposit",
  },
  {
    id: "coupon",
    label: "เครดิตโค้ด",
    icon: "fluent-color:gift-card-24",
    component: CouponTab,
    group: "promotion",
  },
  {
    id: "refund",
    label: "คืนยอดเสีย",
    icon: "fluent-color:arrow-sync-16",
    component: RefundTab,
    group: "promotion",
  },
  {
    id: "bonus",
    label: "แรงค์กิ้ง",
    icon: "fluent-color:ribbon-star-32",
    component: BonusTab,
    group: "promotion",
  },
  {
    id: "refer",
    label: "แนะนำเพื่อน",
    icon: "fluent-color:people-community-20",
    component: ReferFriendTab,
    group: "menu",
  },
  {
    id: "wheelspin",
    label: "กงล้อพารวย",
    icon: "glyphs-poly:target",
    component: WheelSpinTab,
    group: "entertainment",
  },
  {
    id: "review",
    label: "รีวิว",
    icon: "fluent-color:clipboard-text-edit-20",
    component: ReviewTab,
    group: "menu",
  },
];

export const menuSections = [
  {
    id: "promotion",
    label: "โปรโมชั่น",
    icon: "fluent-color:gift-20",
  },
  {
    id: "deposit",
    label: "ฝาก-ถอน",
    icon: "fluent-color:vault-20",
  },
  {
    id: "menu",
    label: "กิจกรรม",
    icon: "fluent-color:person-16",
  },
];
